module.exports = __webpack_public_path__ + "static/signature-6a97bd78a87b06c10c6d68c05fae77ed.svg";